import React, { useEffect, useState } from "react";
import "./DestinationsWeCover.css";

const SHEET_URL =
  "https://docs.google.com/spreadsheets/d/e/2PACX-1vSTC4geKOPLbI1NqbhdwPxng7IRjqHD2-mrcPpJqkG0AgxOGFCvndHDnVNmT66wPAInI8sTAAyobVsF/pub?output=csv"; // Replace with your actual published link

const DestinationsWeCover = () => {
  const [destinations, setDestinations] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    fetch(SHEET_URL)
      .then((res) => res.text())
      .then((text) => {
        const rows = text.split("\n").slice(1); // skip header
        const parsed = rows.map((row) => {
          const [Title, ImageURL, Description] = row.split(",");
          return { Title, ImageURL, Description };
        });
        setDestinations(parsed);
      });
  }, []);

  return (
    <div className="destinations-container">
      <h2 className="section-heading">Destinations We Cover</h2>

      <div className="slider-wrapper">
        <div className="slider-track">
          {destinations.map((item, index) => (
            <div
              className="destination-card"
              key={index}
              onClick={() => setActive(item)}
            >
              <img src={item.ImageURL} alt={item.Title} />
              <h4>{item.Title}</h4>
            </div>
          ))}
        </div>
      </div>

      {active && (
        <div className="popup-overlay" onClick={() => setActive(null)}>
          <div className="popup-card" onClick={(e) => e.stopPropagation()}>
            <h3>{active.Title}</h3>
            <p>{active.Description}</p>
            <a
              href={`https://wa.me/918639421663?text=I want to know more about ${active.Title}`}
              target="_blank"
              rel="noreferrer"
              className="whatsapp-btn"
            >
              Know More
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default DestinationsWeCover;
